// extracted by mini-css-extract-plugin
module.exports = {"name":"Login_name__qYiaU","icon1":"Login_icon1__aNkEv","realname":"Login_realname__1DBfZ","email":"Login_email__1DAEo","gmail":"Login_gmail__3F4X3","box":"Login_box__2Nny-"};